export default __webpack_public_path__ + "static/media/correct19.cf82bebc.mp3";